

/**
 * REGEX Used For Validation of Email ID.
 */
export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;
/**
 * REGEX Used For Validation of positive float Number.
 */
                               
export const FLOAT_NUM_REGEX = /(?:^| )\d+(\.\d+)?(?=$| )|(?:^| )\.\d+(?=$| )|(?:^| )\d+(\.)?(?=$| )$/;
/**
 * REGEX Used For Validation of Negative float Number.
 */
export const FLOAT_NUM_WITH_NEG_REGEX =/(?:^| )[-]?\d+(\.\d+)?(?=$| )|(?:^| )[-]?\.\d+(?=$| )|(?:^| )[-]?\d+(\.)?(?=$| )$/;
/**
 * REGEX Used For Validation of positive integer.
 */
export const INT_NUM_REGEX = /^[0-9]+$/;
/**
 * REGEX Used For Validation of negative integer.
 */
export const INT_NUM_WITH_NEG_REGEX =/^[-]?[0-9]+$/;
/**
 * REGEX Used For Validation of Temperature.
 */
export const TEMPERATURE_REGEX =/[.+-]/g;
/**
 * Const used get Type Validation Error Message.
 */
export const VALIDATOR_MAP = {
  REQUIRED: 'REQUIRED',
  MIN_LENGTH: 'MIN_LENGTH',
  MAX_LENGTH: 'MAX_LENGTH',
  EMAIL: 'EMAIL'
};
/**
 * Const used to Match with user Type to create the matched Type of input Field.
 */
export const FN_INPUT_TYPES = {
  TEXT: 'TEXT',
  PASSWORD: 'PASSWORD',
  STRING: 'STRING',
  PHONENUMBER: 'PHONENUMBER',
  NUMBER: 'NUMBER',
  CURRENCY: 'CURRENCY',
  FLOAT: 'FLOAT',
  DOUBLE: 'DOUBLE',
  EMAIL: 'EMAIL',
  BOOL: 'BOOL',
  TEXTAREA: 'TEXTAREA',
  LOOKUP: 'LOOKUP',
  MULTILOOKUP: 'MULTILOOKUP',
  COLOR: 'COLOR',
  TEMPERATURE: 'TEMPERATURE'
};
export const FN_INPUT_DEFAULT_FORMAT:any = {
  TEMPERATURE:  'f',
  CURRENCY: '$',
  TEXT:''
}
// export const enum FN_INPUT_TYPES {
//  TEXT = 'TEXT',
//  PASSWORD = 'PASSWORD',
//  STRING = 'STRING',
//  PHONENUMBER = 'PHONENUMBER',
//  NUMBER = 'NUMBER',
//  CURRENCY = 'CURRENCY',
//  FLOAT = 'FLOAT',
//  DOUBLE = 'DOUBLE',
//  EMAIL = 'EMAIL',
//  BOOL = 'BOOL',
//  TEXTAREA = 'TEXTAREA',
//  LOOKUP = 'LOOKUP',
//  MULTILOOKUP = 'MULTILOOKUP',
//  COLOR = 'COLOR'
// }


